import { Box } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';

export type ThumbnailImageProps = {
  imageUrl?: string;
  altText?: string;
  size?: number;
};

export const ThumbnailImage = ({
  imageUrl,
  altText = 'Thumbnail',
  size = 40,
}: ThumbnailImageProps) => {
  if (imageUrl) {
    return (
      <Box
        component='img'
        src={imageUrl}
        alt={altText}
        sx={{
          width: size,
          height: size,
          borderRadius: 1,
          objectFit: 'cover',
          flex: 'none',
          order: 0,
          flexGrow: 0,
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: size,
        height: size,
        backgroundColor: 'text.secondary',
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 'none',
        order: 0,
        flexGrow: 0,
      }}
    >
      <ImageIcon
        sx={{
          color: 'white',
          fontSize: size * 0.5,
        }}
      />
    </Box>
  );
};
